import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createCarrierFailed, createCarrierSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createCarrier(action) {
  try {
    const url = `${BACKEND_URL}/registries/carriers`;
    const pool = action.payload;
    delete pool.number;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === CREATED) {
      yield put(createCarrierSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(createCarrierFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(createCarrierFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
